import { StateCreator } from "zustand";

export interface UserSlice {
  userId?: string;
  setUserId?: (id: string) => void;
}

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
  userId: undefined,
  setUserId: (userId: string) => set({ userId: userId }),
});
